import { InfoIcon } from "@vwfs-bronson/bronson-react";

export const InfoIconWrapper = ({ tippyProps, ...props }: any) => {
  return (
    <InfoIcon tippyProps={tippyProps || { placement: "top-start" }} {...props}>
      {props?.children}
    </InfoIcon>
  );
};
